export const OUTCOME_TEXT_DELIMITER = "\n\n";
export const OUTCOME_SELECTION_TILES = [
    {
        key: "technicalConfidenceCall",
        title: "Confidence Call - Technical",
        description: "Technical deep-dive with engineering to review the issue and next steps.",
        submissionText: "Requesting a technical confidence call with engineering to review the issue, current impact, investigation status, and next steps.",
        iconName: "DeveloperTools",
        iconColor: "blue",
    },
    {
        key: "executiveConfidenceCall",
        title: "Confidence Call - Executive",
        description: "Executive alignment on customer impact, ownership, and communications.",
        submissionText: "Requesting an executive confidence call to align on customer impact, response strategy, ownership, and communications.",
        iconName: "People",
        iconColor: "purple",
    },
    {
        key: "prePirEngagement",
        title: "Pre-PIR engagement",
        description: "Urgent engagement before the post-incident review is complete.",
        submissionText: "Requesting urgent engagement before the PIR is complete to review the incident and current findings.",
        iconName: "Timer",
        iconColor: "orange",
    },
    {
        key: "rcaPirFollowUp",
        title: "RCA / PIR follow-up questions",
        description: "Follow-up on the root cause analysis or PIR and outstanding questions.",
        submissionText: "Requesting follow-up on the root cause analysis or PIR and answers to outstanding questions.",
        iconName: "Questionnaire",
        iconColor: "red",
    },
    {
        key: "advisoryGuidance",
        title: "Advisory / Guidance",
        description: "Written advisory guidance when live incident response is not required.",
        submissionText: "Requesting written advisory guidance for this issue; no live incident response is required.",
        iconName: "Lightbulb",
        iconColor: "teal",
    },
    {
        key: "engineeringEngagement",
        title: "Engineering Engagement",
        description: "Direct engineering investigation and support to help unblock the issue.",
        submissionText: "Requesting direct engineering engagement to investigate and help unblock the issue.",
        iconName: "EngineeringGroup",
        iconColor: "green",
    },
];
export const buildDesiredOutcome = (selectedKeys, isOtherSelected, otherText) => {
    const selectedKeySet = new Set(selectedKeys);
    const entries = OUTCOME_SELECTION_TILES.filter((tile) => selectedKeySet.has(tile.key)).map((tile) => tile.submissionText);
    const normalizedOtherText = otherText.trim();
    if (isOtherSelected && normalizedOtherText) {
        entries.push(normalizedOtherText);
    }
    return entries.join(OUTCOME_TEXT_DELIMITER);
};
export const parseDesiredOutcome = (desiredOutcome) => {
    const entries = desiredOutcome
        .split(/\r?\n\s*\r?\n/)
        .map((entry) => entry.trim())
        .filter(Boolean);
    const knownSubmissionText = new Set(OUTCOME_SELECTION_TILES.map((tile) => tile.submissionText));
    const selectedKeys = OUTCOME_SELECTION_TILES.filter((tile) => entries.includes(tile.submissionText)).map((tile) => tile.key);
    const otherEntries = entries.filter((entry) => !knownSubmissionText.has(entry));
    return {
        selectedKeys,
        isOtherSelected: otherEntries.length > 0,
        otherText: otherEntries.join(OUTCOME_TEXT_DELIMITER),
    };
};
